import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ServiceBase } from "./service-base";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { HydrantLog } from "../data-objects/hydrant-log";
import { User } from "../data-objects/user";

@Injectable()
export class HydrantLogService extends ServiceBase {
  public static get createLogUrl(): string {
    return ServiceBase.baseHref + "/createlog";
  }
  public static get getLogsUrl(): string {
    return ServiceBase.baseHref + "/api/hydrantlog/";
  }
  private hydrantLog: HydrantLog;

  constructor(private http: HttpClient) {
    super();
  }

  register(
    hydrantLog: HydrantLog[],
    okCb: (boolean) => void,
    errorCb?: (any) => void
  ): void {
    const logs: HydrantLog = ServiceBase.sanitize(hydrantLog);


    
    this.http
      .post(HydrantLogService.createLogUrl,{data:logs}, {
        headers: new HttpHeaders({ "Content-Type": "application/json" }),
      })
      .subscribe(
        (data) => {
          this.hydrantLog = null;
          okCb(true);
        },
        (err) => {
          ServiceBase.handleError(err, errorCb);
        }
      );

    // this.http.post(HydrantLogService.createLogUrl, {
    //     accountNumber: accountNumber,
    //     permitHolderName: accountName,
    //     permitNo: log.permitNo,
    //     vehicleRegistrationNo: log.vehicleRegistrationNo,
    //     streetNo: log.streetNo,
    //     streetName: log.streetName,
    //     suburb: log.suburb,
    //     month: log.month,
    //     kiloLitreTaken: log.kiloLitreTaken
    //   },
    //   {headers: new HttpHeaders({'Content-Type': 'application/json'})}).subscribe(data => {
    //   this.hydrantLog = null;
    //   okCb(true);
    // }, err => {
    //   ServiceBase.handleError(err, errorCb);
    // });
  }

  getMyLogs(
    user: User,
    accountNumber: string,
    permitNumber: string,
    registrationNumber: string,
    month: string
  ): Observable<HydrantLog[]> {
    const header: HttpHeaders = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("Authorization", "Bearer " + user.token);
    const url: string = HydrantLogService.getLogsUrl;
    if (accountNumber || permitNumber || registrationNumber || month) {
      const params: HttpParams = new HttpParams()
        .set("accountNumber", accountNumber)
        .append("permitNumber", permitNumber)
        .append("registrationNumber", registrationNumber)
        .append("month", month);
      return this.http.get<HydrantLog[]>(url, {
        headers: header,
        params: params,
      });
    } else {
      return this.http.get<HydrantLog[]>(url, { headers: header });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/hydrantlog.service.ts